export default __webpack_public_path__ + "static/media/section2_4_1.93371b52.png";